export const ROUTES = {
  LOGIN: '/login',
  WELCOME: '/welcome',

  ROOT: '/',

  ADMIN: '/admin',
  ADMIN_LEADS: '/admin/leads',
  ADMIN_QUOTES: '/admin/quotes',
  ADMIN_SALES: '/admin/sales',
  ADMIN_CUSTOMERS: '/admin/customers',
  ADMIN_MARKETING: '/admin/marketing',
  ADMIN_DCR: '/admin/dcr',
  ADMIN_PURCHASE: '/admin/purchase',

  SALES: '/sales',
  SALES_LEADS: '/sales/leads',
  SALES_QUOTES: '/sales/quotes',
  SALES_CUSTOMERS: '/sales/customers',
  SALES_DCR: '/sales/dcr',

  MARKETING: '/marketing',
  MARKETING_LEADS: '/marketing/leads',
  MARKETING_QUOTES: '/marketing/quotes',
  MARKETING_CUSTOMERS: '/marketing/customers',

  PURCHASE: '/purchase',
  PURCHASE_PREVIEW: '/purchase/preview',
}
